var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.kind,attrs:{"target":_vm.dataTarget,"title":_vm.dataTitle}},[_c('i',{class:_vm.icon}),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }